import CivilEngineering from "../../../Images/CivilEngineering.png";
import ElectricalEngineering from "../../../Images/ElectricalEngineering.png";
import MechanicalEngineering from "../../../Images/MechanicalEngineering.png";
import ElectronicsEngineering from "../../../Images/ElectronicsEngineering.png";
import ComputerScienceEngineering from "../../../Images/ComputerScienceEngineering.png";
import InformationTechnology from "../../../Images/InformationTechnology.png";

// Image array
const courseData = [
  {
    image: CivilEngineering,
    name: "Civil Engineering",
    desc:
      "Our Civil Engineering books furnish the students with the knowledge to apply various principles of Mathematics and Science in solving real-life engineering problems through a range of private and public projects.",
  },
  {
    image: ElectricalEngineering,
    name: "Electrical Engineering",
    desc:
      "Once a student is through with our books, he/she will be fully capable to perform the tasks of an electrical engineer which involve the use of electricity to solve problems related to energy, the environment and many more.",
  },
  {
    image: MechanicalEngineering,
    name: "Mechanical Engineering",
    desc:
      "Our mechanical books not only empower you to carefully build structurally-sound devices but also effectively fix existing problems in mechanical projects through a critical understanding of theoretical and practical concepts.",
  },
  {
    image: ElectronicsEngineering,
    name: "Electronics Engineering",
    desc:
      "By the virtue of our books, our students will be able to perform their duties aselectronics engineers or apply these concepts for further studies which cover sub-fields such as analogue electronics, digital electronics, consumer electronics and many more.",
  },
  {
    image: ComputerScienceEngineering,
    name: "Computer Science Engineering",
    desc:
      "Our computer science books will not only train you to understand the basic fundamentals but will also allow you to have complete knowledge of programming languages so that you can fully excel in your desired field.",
  },
  {
    image: InformationTechnology,
    name: "Information Technology",
    desc:
      "In order to cope with the challenges of handling new technologies, materials, and methods of information technology, our books aim to develop aspiring students like you with appropriate professional knowledge, skills, and attitude to fully solve these problems.",
  },
];

export default courseData;
